import React, { useEffect, useState } from "react";
import "./sales-dashboard.css"; // we'll write CSS separately
import RM_UI from "./rm_ui";
import MR_UI from "./mr_ui";
import ZM_UI from "./zm_ui";
import apiClient from "../../service/interceptor";

export default function SalesDashboard() {
    const [activeTab, setActiveTab] = useState("ZM");


    var mr_data = {
        "success": true,
        "code": 200,
        "data": {
            "results": [
                {
                    "period_start": "2025-08-01T00:00:00.000Z",
                    "period_end": "2025-08-07T00:00:00.000Z",
                    "secure_code_verified": "heal6754",
                    "usage_count": 4
                },
                {
                    "period_start": "2025-08-08T00:00:00.000Z",
                    "period_end": "2025-08-14T00:00:00.000Z",
                    "secure_code_verified": "heal6754",
                    "usage_count": 1
                },
                {
                    "period_start": "2025-08-15T00:00:00.000Z",
                    "period_end": "2025-08-21T00:00:00.000Z",
                    "secure_code_verified": "heal6754",
                    "usage_count": 6
                },
                {
                    "period_start": "2025-08-22T00:00:00.000Z",
                    "period_end": "2025-08-28T00:00:00.000Z",
                    "secure_code_verified": "heal6754",
                    "usage_count": 4
                },
                {
                    "period_start": "2025-08-29T00:00:00.000Z",
                    "period_end": "2025-08-31T00:00:00.000Z",
                    "secure_code_verified": null,
                    "usage_count": 0
                }
            ],
            "monthlyUsersCount": [
                {
                    "month": "September 2025",
                    "start": "2025-09-01T00:00:00.000Z",
                    "end": "2025-09-30T00:00:00.000Z",
                    "count": 8
                },
                {
                    "month": "August 2025",
                    "start": "2025-08-01T00:00:00.000Z",
                    "end": "2025-08-31T00:00:00.000Z",
                    "count": 15
                },
                {
                    "month": "July 2025",
                    "start": "2025-07-01T00:00:00.000Z",
                    "end": "2025-07-31T00:00:00.000Z",
                    "count": 72
                },
                {
                    "month": "June 2025",
                    "start": "2025-06-01T00:00:00.000Z",
                    "end": "2025-06-30T00:00:00.000Z",
                    "count": 100
                },
                {
                    "month": "May 2025",
                    "start": "2025-05-01T00:00:00.000Z",
                    "end": "2025-05-31T00:00:00.000Z",
                    "count": 251
                },
                {
                    "month": "April 2025",
                    "start": "2025-04-01T00:00:00.000Z",
                    "end": "2025-04-30T00:00:00.000Z",
                    "count": 34
                }
            ],
            "mrPainAvg": {
                "pain1Avg": 4,
                "pain2Avg": null,
                "overAllPainAvg": 4
            }
        }
    }

    var rm_data = {
        "success": true,
        "code": 200,
        "data": {
            "results": [
                {
                    "mrName": "first MR",
                    "mrCodeData": [
                        {
                            "period_start": "2025-08-01T00:00:00.000Z",
                            "period_end": "2025-08-07T00:00:00.000Z",
                            "secure_code_verified": "heal6754",
                            "usage_count": 4
                        },
                        {
                            "period_start": "2025-08-08T00:00:00.000Z",
                            "period_end": "2025-08-14T00:00:00.000Z",
                            "secure_code_verified": "heal6754",
                            "usage_count": 1
                        },
                        {
                            "period_start": "2025-08-15T00:00:00.000Z",
                            "period_end": "2025-08-21T00:00:00.000Z",
                            "secure_code_verified": "heal6754",
                            "usage_count": 6
                        },
                        {
                            "period_start": "2025-08-22T00:00:00.000Z",
                            "period_end": "2025-08-28T00:00:00.000Z",
                            "secure_code_verified": "heal6754",
                            "usage_count": 4
                        },
                        {
                            "period_start": "2025-08-29T00:00:00.000Z",
                            "period_end": "2025-08-31T00:00:00.000Z",
                            "secure_code_verified": null,
                            "usage_count": 0
                        }
                    ]
                },
                {
                    "mrName": "second MR",
                    "mrCodeData": [
                        {
                            "period_start": "2025-08-01T00:00:00.000Z",
                            "period_end": "2025-08-07T00:00:00.000Z",
                            "secure_code_verified": "healm036",
                            "usage_count": 2
                        },
                        {
                            "period_start": "2025-08-08T00:00:00.000Z",
                            "period_end": "2025-08-14T00:00:00.000Z",
                            "secure_code_verified": "healm036",
                            "usage_count": 12
                        },
                        {
                            "period_start": "2025-08-15T00:00:00.000Z",
                            "period_end": "2025-08-21T00:00:00.000Z",
                            "secure_code_verified": "healm036",
                            "usage_count": 6
                        },
                        {
                            "period_start": "2025-08-22T00:00:00.000Z",
                            "period_end": "2025-08-28T00:00:00.000Z",
                            "secure_code_verified": "healm036",
                            "usage_count": 3
                        },
                        {
                            "period_start": "2025-08-29T00:00:00.000Z",
                            "period_end": "2025-08-31T00:00:00.000Z",
                            "secure_code_verified": null,
                            "usage_count": 0
                        }
                    ]
                },
                {
                    "mrName": "third MR",
                    "mrCodeData": [
                        {
                            "period_start": "2025-08-01T00:00:00.000Z",
                            "period_end": "2025-08-07T00:00:00.000Z",
                            "secure_code_verified": "healm689",
                            "usage_count": 2
                        },
                        {
                            "period_start": "2025-08-08T00:00:00.000Z",
                            "period_end": "2025-08-14T00:00:00.000Z",
                            "secure_code_verified": "healm689",
                            "usage_count": 7
                        },
                        {
                            "period_start": "2025-08-15T00:00:00.000Z",
                            "period_end": "2025-08-21T00:00:00.000Z",
                            "secure_code_verified": "healm689",
                            "usage_count": 5
                        },
                        {
                            "period_start": "2025-08-22T00:00:00.000Z",
                            "period_end": "2025-08-28T00:00:00.000Z",
                            "secure_code_verified": "healm689",
                            "usage_count": 5
                        },
                        {
                            "period_start": "2025-08-29T00:00:00.000Z",
                            "period_end": "2025-08-31T00:00:00.000Z",
                            "secure_code_verified": "healm689",
                            "usage_count": 1
                        }
                    ]
                }
            ],
            "monthlyUsersCount": [
                {
                    "month": "September 2025",
                    "start": "2025-09-01T00:00:00.000Z",
                    "end": "2025-09-30T00:00:00.000Z",
                    "count": 12
                },
                {
                    "month": "August 2025",
                    "start": "2025-08-01T00:00:00.000Z",
                    "end": "2025-08-31T00:00:00.000Z",
                    "count": 57
                },
                {
                    "month": "July 2025",
                    "start": "2025-07-01T00:00:00.000Z",
                    "end": "2025-07-31T00:00:00.000Z",
                    "count": 123
                },
                {
                    "month": "June 2025",
                    "start": "2025-06-01T00:00:00.000Z",
                    "end": "2025-06-30T00:00:00.000Z",
                    "count": 155
                },
                {
                    "month": "May 2025",
                    "start": "2025-05-01T00:00:00.000Z",
                    "end": "2025-05-31T00:00:00.000Z",
                    "count": 300
                },
                {
                    "month": "April 2025",
                    "start": "2025-04-01T00:00:00.000Z",
                    "end": "2025-04-30T00:00:00.000Z",
                    "count": 41
                }
            ],
            "rmPainAvg": {
                "pain1Avg": 12,
                "pain2Avg": 0,
                "overAllPainAvg": 6
            },
            "mrPainAvg": {
                "pain1Avg": 4,
                "pain2Avg": null,
                "overAllPainAvg": 4
            }
        }
    }

    var zm_data = {
        "success": true,
        "code": 200,
        "data": {
            "results": [
                {
                    "rmName": "first RM",
                    "rmTotal": [
                        {
                            "period_start": "2025-08-01T00:00:00.000Z",
                            "period_end": "2025-08-07T00:00:00.000Z",
                            "secure_code_verified": "heal6754",
                            "usage_count": 8
                        },
                        {
                            "period_start": "2025-08-08T00:00:00.000Z",
                            "period_end": "2025-08-14T00:00:00.000Z",
                            "secure_code_verified": "heal6754",
                            "usage_count": 20
                        },
                        {
                            "period_start": "2025-08-15T00:00:00.000Z",
                            "period_end": "2025-08-21T00:00:00.000Z",
                            "secure_code_verified": "heal6754",
                            "usage_count": 17
                        },
                        {
                            "period_start": "2025-08-22T00:00:00.000Z",
                            "period_end": "2025-08-28T00:00:00.000Z",
                            "secure_code_verified": "heal6754",
                            "usage_count": 12
                        },
                        {
                            "period_start": "2025-08-29T00:00:00.000Z",
                            "period_end": "2025-08-31T00:00:00.000Z",
                            "secure_code_verified": null,
                            "usage_count": 1
                        }
                    ],
                    "mrData": [
                        {
                            "mrName": "first MR",
                            "mrCodeData": [
                                {
                                    "period_start": "2025-08-01T00:00:00.000Z",
                                    "period_end": "2025-08-07T00:00:00.000Z",
                                    "secure_code_verified": "heal6754",
                                    "usage_count": 4
                                },
                                {
                                    "period_start": "2025-08-08T00:00:00.000Z",
                                    "period_end": "2025-08-14T00:00:00.000Z",
                                    "secure_code_verified": "heal6754",
                                    "usage_count": 1
                                },
                                {
                                    "period_start": "2025-08-15T00:00:00.000Z",
                                    "period_end": "2025-08-21T00:00:00.000Z",
                                    "secure_code_verified": "heal6754",
                                    "usage_count": 6
                                },
                                {
                                    "period_start": "2025-08-22T00:00:00.000Z",
                                    "period_end": "2025-08-28T00:00:00.000Z",
                                    "secure_code_verified": "heal6754",
                                    "usage_count": 4
                                },
                                {
                                    "period_start": "2025-08-29T00:00:00.000Z",
                                    "period_end": "2025-08-31T00:00:00.000Z",
                                    "secure_code_verified": null,
                                    "usage_count": 0
                                }
                            ]
                        },
                        {
                            "mrName": "second MR",
                            "mrCodeData": [
                                {
                                    "period_start": "2025-08-01T00:00:00.000Z",
                                    "period_end": "2025-08-07T00:00:00.000Z",
                                    "secure_code_verified": "healm036",
                                    "usage_count": 2
                                },
                                {
                                    "period_start": "2025-08-08T00:00:00.000Z",
                                    "period_end": "2025-08-14T00:00:00.000Z",
                                    "secure_code_verified": "healm036",
                                    "usage_count": 12
                                },
                                {
                                    "period_start": "2025-08-15T00:00:00.000Z",
                                    "period_end": "2025-08-21T00:00:00.000Z",
                                    "secure_code_verified": "healm036",
                                    "usage_count": 6
                                },
                                {
                                    "period_start": "2025-08-22T00:00:00.000Z",
                                    "period_end": "2025-08-28T00:00:00.000Z",
                                    "secure_code_verified": "healm036",
                                    "usage_count": 3
                                },
                                {
                                    "period_start": "2025-08-29T00:00:00.000Z",
                                    "period_end": "2025-08-31T00:00:00.000Z",
                                    "secure_code_verified": null,
                                    "usage_count": 0
                                }
                            ]
                        },
                        {
                            "mrName": "third MR",
                            "mrCodeData": [
                                {
                                    "period_start": "2025-08-01T00:00:00.000Z",
                                    "period_end": "2025-08-07T00:00:00.000Z",
                                    "secure_code_verified": "healm689",
                                    "usage_count": 2
                                },
                                {
                                    "period_start": "2025-08-08T00:00:00.000Z",
                                    "period_end": "2025-08-14T00:00:00.000Z",
                                    "secure_code_verified": "healm689",
                                    "usage_count": 7
                                },
                                {
                                    "period_start": "2025-08-15T00:00:00.000Z",
                                    "period_end": "2025-08-21T00:00:00.000Z",
                                    "secure_code_verified": "healm689",
                                    "usage_count": 5
                                },
                                {
                                    "period_start": "2025-08-22T00:00:00.000Z",
                                    "period_end": "2025-08-28T00:00:00.000Z",
                                    "secure_code_verified": "healm689",
                                    "usage_count": 5
                                },
                                {
                                    "period_start": "2025-08-29T00:00:00.000Z",
                                    "period_end": "2025-08-31T00:00:00.000Z",
                                    "secure_code_verified": "healm689",
                                    "usage_count": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "rmName": "second RM",
                    "rmTotal": [],
                    "mrData": []
                }
            ],
            "monthlyUsersCount": [
                {
                    "month": "September 2025",
                    "start": "2025-09-01T00:00:00.000Z",
                    "end": "2025-09-30T00:00:00.000Z",
                    "count": 12
                },
                {
                    "month": "August 2025",
                    "start": "2025-08-01T00:00:00.000Z",
                    "end": "2025-08-31T00:00:00.000Z",
                    "count": 57
                },
                {
                    "month": "July 2025",
                    "start": "2025-07-01T00:00:00.000Z",
                    "end": "2025-07-31T00:00:00.000Z",
                    "count": 123
                },
                {
                    "month": "June 2025",
                    "start": "2025-06-01T00:00:00.000Z",
                    "end": "2025-06-30T00:00:00.000Z",
                    "count": 155
                },
                {
                    "month": "May 2025",
                    "start": "2025-05-01T00:00:00.000Z",
                    "end": "2025-05-31T00:00:00.000Z",
                    "count": 300
                },
                {
                    "month": "April 2025",
                    "start": "2025-04-01T00:00:00.000Z",
                    "end": "2025-04-30T00:00:00.000Z",
                    "count": 41
                }
            ],
            "zmPainAvg": {
                "pain1Avg": 12,
                "pain2Avg": 0,
                "overAllPainAvg": 6
            },
            "rmPainAvg": {
                "pain1Avg": 12,
                "pain2Avg": 0,
                "overAllPainAvg": 6
            }
        }
    }



    async function getDataForRole(role) {
        var rep = await apiClient.post('/v1/analytics/therapy/mr-data-analysis',
            {
                "email": "firstZm@gmail.com",
                "fromDate": "2025-08-01",
                "toDate": "2025-08-31",
                "dataType": 1
            });

        if (rep.status === 200) {
            console.log(rep.data);
        }

    }

    useEffect(() => {
        getDataForRole("ZM");
    }, []);

    return (
        <div className="app">
            {/* ---------- HEADER ---------- */}
            <header className="header">
                <h1>MyFlexa Sales Analytics Dashboard</h1>
                {/* Simple Select Dropdown */}
                <select className="user-select">
                    <option>John Smith (ZM)</option>
                    <option>Jane Doe (RM)</option>
                    <option>Mark Taylor (MR)</option>
                    <option>Logout</option>
                </select>
            </header>

            {/* ---------- TABS ---------- */}
            <div className="tabs">
                <button
                    className={activeTab === "ZM" ? "tab active" : "tab"}
                    onClick={() => setActiveTab("ZM")}
                >
                    ZM
                </button>
                <button
                    className={activeTab === "RM" ? "tab active" : "tab"}
                    onClick={() => setActiveTab("RM")}
                >
                    RM
                </button>
                <button
                    className={activeTab === "MR" ? "tab active" : "tab"}
                    onClick={() => setActiveTab("MR")}
                >
                    MR
                </button>
            </div>
            {/* ---------- CONTENT ---------- */}
            {activeTab === "ZM" && <ZM_UI data={zm_data.data} />}
            {activeTab === "RM" && <RM_UI data={rm_data.data} />}
            {activeTab === "MR" && <MR_UI data={mr_data.data} />}
        </div>
    );
}
